export namespace Pieces {
  export namespace Plugin {
    export const Name = 'pieces';
  }
}
